import Icon from '../components/Icon.vue'

Icon.register({
  'file-signature': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M218.2 424.1C215.2 418.2 210.1 417.6 208 417.6S200.8 418.2 198 423.8L190.3 439.1C183.9 451.9 165.3 450.5 160.8 437.1L144 386.6 133.4 418.5C127.5 436.1 111 448 92.4 448H80C71.2 448 64 440.8 64 432S71.2 416 80 416H92.4C97.2 416 101.5 412.9 103 408.3L121.2 353.7C124.5 343.9 133.7 337.3 144 337.3S163.5 343.9 166.8 353.7L180.7 395.3C200.4 379.1 234.7 385.6 246.7 409.5 248.5 413.3 252.1 415.4 256 415.8V333.6L384 206.6V160H248C234.8 160 224 149.2 224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V448L256 447.9C239.9 447.6 225.4 438.6 218.2 424.1zM384 121.9C384 115.6 381.5 109.5 377 105L279.1 7C274.6 2.5 268.5 0 262.1 0H256V128H384V121.9zM288 347V416H357L518.7 253.2 450.8 185.3 288 347zM568.5 167.3L536.7 135.5C526.7 125.5 510.6 125.5 500.7 135.5L473.4 162.7 541.3 230.6 568.5 203.3C578.5 193.4 578.5 177.3 568.5 167.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-signature.js
// module id = jGbk
// module chunks = 144